import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import ContentRoutes from 'ContentUtils/Routes';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { allFinishedWithSuccess, anyRequestsFailed, anyRequestsPending } from 'settings-ui-lib/utils/requestStatusChecks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublishNoticeAccessGroupsDropdown = ({
  accessGroups,
  accessGroupsRequestStatus
}) => {
  const [agSectionIsOpen, setAgSectionIsOpen] = useState(false);
  const AGSectionTitle = agSectionIsOpen ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "contentAccessControl.settingsPublishNotice.accessGroupsListSection.title.hide"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "contentAccessControl.settingsPublishNotice.accessGroupsListSection.title.show"
  });
  const handleAgSectionOpenChange = e => {
    setAgSectionIsOpen(e.target.value);
  };
  if (anyRequestsFailed(accessGroupsRequestStatus)) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UIAccordionItem, {
    className: "m-top-2",
    title: AGSectionTitle,
    open: agSectionIsOpen,
    onOpenChange: handleAgSectionOpenChange,
    children: [allFinishedWithSuccess(accessGroupsRequestStatus) && /*#__PURE__*/_jsx(List, {
      paddingInlineStart: "600",
      paddingBlockEnd: "400",
      styled: true,
      children: accessGroups.map(accessGroup => /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "contentAccessControl.settingsPublishNotice.accessGroupsListSection.accessGroupItem_jsx",
          options: {
            agDetailsLink: ContentRoutes.accessGroups(`access-groups/group/${accessGroup.id}/members`),
            accessGroupName: accessGroup.name,
            memberCount: accessGroup.size
          },
          elements: {
            UILink
          }
        }, accessGroup.id)
      }, `access-group-${accessGroup.id}`))
    }), anyRequestsPending(accessGroupsRequestStatus) && /*#__PURE__*/_jsx(UILoadingSpinner, {})]
  });
};
export default PublishNoticeAccessGroupsDropdown;